<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-four-columns>
            <fui-column>
                <wbo-single-select-edit-control [formControlName]="dateRangePeriodField" [label]="'wbo.report.edit.field.dateRangePeriod.label'"
                                                [placeholder]="'wbo.report.edit.field.dateRangePeriod.placeholder'"
                                                [(ngModel)]="model.data[dateRangePeriodField]"
                                                [allowClearSelectionOption]="false" [readonly]="disabled">
                    <wbo-select-options>
                        <wbo-select-option [value]="'CUSTOM'"
                                           label="wbo.report.option.period.custom">
                        </wbo-select-option>
                        <wbo-select-option [value]="'TODAY'"
                                           label="wbo.report.option.period.today">
                        </wbo-select-option>
                        <wbo-select-option [value]="'TOMORROW'"
                                           label="wbo.report.option.period.tomorrow">
                        </wbo-select-option>
                        <wbo-select-option [value]="'YESTERDAY'"
                                           label="wbo.report.option.period.yesterday">
                        </wbo-select-option>
                        <wbo-select-option [value]="'YESTERDAY_MIDNIGHT'"
                                           label="wbo.report.option.period.yesterday-midnight">
                        </wbo-select-option>
                        <wbo-select-option [value]="'LAST_WEEK'"
                                           label="wbo.report.option.period.last-week">
                        </wbo-select-option>
                        <wbo-select-option [value]="'THIS_WEEK'"
                                           label="wbo.report.option.period.this-week">
                        </wbo-select-option>
                        <wbo-select-option [value]="'LAST_MONTH'"
                                           label="wbo.report.option.period.last-month">
                        </wbo-select-option>
                        <wbo-select-option [value]="'THIS_MONTH'"
                                           label="wbo.report.option.period.this-month">
                        </wbo-select-option>
                        <wbo-select-option [value]="'LAST_YEAR'"
                                           label="wbo.report.option.period.last-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'THIS_YEAR'"
                                           label="wbo.report.option.period.this-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'LAST_FINANCIAL_QUARTER'"
                                           label="wbo.report.option.period.last-financial-quarter">
                        </wbo-select-option>
                        <wbo-select-option [value]="'THIS_FINANCIAL_QUARTER'"
                                           label="wbo.report.option.period.this-financial-quarter">
                        </wbo-select-option>
                        <wbo-select-option [value]="'LAST_FINANCIAL_YEAR'"
                                           label="wbo.report.option.period.last-financial-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'THIS_FINANCIAL_YEAR'"
                                           label="wbo.report.option.period.this-financial-year">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-column>
        </fui-four-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-date-edit-control [(ngModel)]="model.data[fromDateField]"
                                           [label]="'wbo.report.edit.field.startDate.label'"
                                           [placeholder]="'wbo.report.edit.field.startDate.placeholder'"
                                           [formControlName]="fromDateField"
                                           [readonly]="isDateControlsReadOnly"></wbo-date-edit-control>
                    <wbo-time-edit-control [(ngModel)]="model.data[fromTimeField]"
                                           [label]="'wbo.report.edit.field.startTime.label'"
                                           [placeholder]="'wbo.report.edit.field.startTime.placeholder'"
                                           [formControlName]="fromTimeField"
                                           [readonly]="isDateControlsReadOnly"></wbo-time-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-date-edit-control [(ngModel)]="model.data[toDateField]"
                                           [label]="'wbo.report.edit.field.finishDate.label'"
                                           [placeholder]="'wbo.report.edit.field.finishDate.placeholder'"
                                           [formControlName]="toDateField"
                                           [readonly]="isDateControlsReadOnly"></wbo-date-edit-control>
                    <wbo-time-edit-control [(ngModel)]="model.data[toTimeField]"
                                           [label]="'wbo.report.edit.field.finishTime.label'"
                                           [placeholder]="'wbo.report.edit.field.finishTime.placeholder'"
                                           [formControlName]="toTimeField"
                                           [readonly]="isDateControlsReadOnly"></wbo-time-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
